var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"common-btn",class:[_vm.type],attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }